import { size } from "lodash";
import { getLightTheme } from "./templates";
import { GlossyTheme } from "./types";

interface IMixinProps {
  theme?: Partial<GlossyTheme>;
}

const getTheme = (props: IMixinProps) =>
  props.theme
    ? size(props.theme)
      ? props.theme
      : getLightTheme()
    : getLightTheme();

export const dominant = (props: IMixinProps) => getTheme(props).dominant;

export const onDominant = (props: IMixinProps) => getTheme(props).onDominant;

export const background = (props: IMixinProps) => getTheme(props).background;

export const content = (
  props: IMixinProps,
  level: keyof GlossyTheme["content"] = "primary"
) => getTheme(props).content[level];

export const chart = (
  props: IMixinProps,
  level: keyof GlossyTheme["chart"] = "primary"
) => getTheme(props).chart[level];

export const border = (props: IMixinProps) => getTheme(props).border;

export const form = (
  props: IMixinProps,
  level: keyof GlossyTheme["form"] = "primary"
) => getTheme(props).form[level];

export const evolution = (
  props: IMixinProps,
  type: keyof GlossyTheme["evolution"]
) => getTheme(props).evolution[type];

export const message = (
  props: IMixinProps,
  type: keyof GlossyTheme["message"]
) => getTheme(props).message[type];
